import React from 'react';
import Link from 'next/link';
import { Button } from 'components';
import { Routes } from 'utils/routes';
import styles from './FormueberegnerHeader.module.scss';

const FormueberegnerHeader = ({ className = '', ...props }) => (
    <header
        className={ [styles.root, className].filter(Boolean).join(' ') }
        style={{
            backgroundColor: '#ffffff',
            width: '100vw',
            maxWidth: 'none',
            marginLeft: 'calc(50% - 50vw)',
            marginRight: 'calc(50% - 50vw)',
        }}
        { ...props }
    >
        <div className={ styles.headerContent }>
            <Link href="/">
                <a className={ styles.headerLogo } aria-label="Penly forside" />
            </Link>
            <Button
                className={ styles.headerCta }
                href={ Routes.Advisory.Investering15.Flow }
            >
                Book gratis møde
            </Button>
        </div>
    </header>
);

export default FormueberegnerHeader;
